import { PackageType } from '../enums/package-type.enum';

export interface CreateOrUpdateLicencePackageDto {
    /**
     * The type of the licence package.
     */
    type: PackageType;

    /**
     * The size of the licence package.
     */
    packageSize: number;

    /**
     * The start date of the licence package.
     */
    startDate: string;

    /**
     * The end date of the licence package.
     */
    endDate: string;

    /**
     * (Optional) Description of the licence package.
     */
    description?: string | undefined;

    /**
     * (Optional) Price of the licence package.
     */
    price?: number | undefined;

    /**
     * (Optional) Discount amount applied to the licence package.
     */
    discountAmount?: number | undefined;

    /**
     * (Optional) Discount percentage applied to the licence package.
     */
    discountPercent?: number | undefined;

    /**
     * The unique identifier for the organization.
     */
    organizationId?: string | undefined;

    packageId?: string | undefined;
}
